var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagUk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 17.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.62,17.29H10v-5.39L1.62,17.29ZM22.62,.03H14V5.66L22.62,.03ZM0,10.55v4.31l6.47-4.31H0ZM0,3v3.77H5.66L0,3ZM10,0H.81L10,5.96V0Zm4,17.26h7.82l-7.82-5.09v5.09ZM24,6.77v3.78h-7l7,4.85V2.73l-6.2,4,6.2,.04Z",
    fill: "#273579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9,10.55L0,16.48v.81H.27l9.73-6.2v-.54h-1.1ZM24,1.66V.57L15.1,6.77h1.35L24,1.66ZM0,1.11v.81L7,6.77h1.63L0,1.11ZM14,10.55v.81l9.17,5.93h.83v-.54l-9.44-6.2h-.56Z",
    fill: "#c32026"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24,.03h-1.35L14,5.66V.03h-.81V7.58h10.81v-.81h-6.2l6.2-4V1.66l-7.55,5.12h-1.35L24,.57V.03Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25,9.74H0v.81H6.47L0,14.86v1.62l8.9-5.93h1.1v.54L.27,17.29H1.62l8.38-5.39v5.39h.81v-7.55h-.56ZM10,.03V5.96L.81,.03H0V1.11L8.63,6.77h-1.63L0,1.92v1.08l5.66,3.77H0v.81H10.79V.03h-.79Zm4.58,10.52l9.42,6.2v-1.35l-7-4.85h7v-.81H13.21v7.55h.79v-5.12l7.82,5.12h1.35l-9.17-5.93v-.81h.58Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.45,7.58h-3.24V.03h-2.42V7.58H0v2.16H10.79v7.55h2.42v-7.55h10.79v-2.16h-7.55Z",
    fill: "#c32026"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUk);
export default __webpack_public_path__ + "static/media/flag-uk.14b84380ee2cc0f48020186cc31234bc.svg";
export { ForwardRef as ReactComponent };